import { TableCell, TableSortLabel } from '@material-ui/core';
import { orderBy } from 'lodash';
import React from 'react';
import VoxelTooltipShort from '../../../../../components/voxel/Tooltip/VoxelTooltipShort';
import { ContentKeywordGq } from '../../../../../graphql/projects/models/ContentKeywordGq';
import { projectsApiService } from '../../../../../graphql/projects/projectsApiService';

export interface HeadCellVolumeProps {
  projectId: number;
  taskId: number;
  taskKeywords: ContentKeywordGq[];
  reload: () => Promise<any>;
}

const HeadCellVolume: React.FC<HeadCellVolumeProps> = ({
  projectId,
  taskId,
  taskKeywords,
  reload,
}) => {
  const taskKeywordIds = orderBy(
    taskKeywords,
    [(a) => a.volume, (a) => a.inTitle, (a) => a.inH1, (a) => a.inContent, (a) => a.id],
    ['desc', 'desc', 'desc', 'desc', 'asc']
  ).map((x) => x.id);
  // Change item order or add item mutation
  const sortByVolumeMutation = projectsApiService.mutations.contentPlan.useChangeKeywordOrder();
  const sortByVolume = () => {
    sortByVolumeMutation({
      projectId,
      contentTaskId: taskId,
      contentKeywordIds: taskKeywordIds,
    }).then(reload);
  };

  return (
    <TableCell align={'right'} component="div">
      <VoxelTooltipShort message={'Sort volume desc'}>
        <TableSortLabel direction={'desc'} active onClick={() => sortByVolume()}>
          Volume
        </TableSortLabel>
      </VoxelTooltipShort>
    </TableCell>
  );
};

export default HeadCellVolume;
